"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTo = void 0;
class AccessTo {
    constructor(items = [], all = false) {
        this.items = [];
        this.all = false;
        this.items = items.map(({ id, title }) => ({ id, title }));
        this.all = all;
    }
    get some() {
        return this.all || this.items.length > 0;
    }
    get many() {
        return this.all || this.items.length > 1;
    }
    get none() {
        return !this.all && this.items.length === 0;
    }
    get first() {
        return this.items.length > 0 ? this.items[0] : undefined;
    }
    get ids() {
        return this.items.map(item => item.id);
    }
    includesId(id) {
        if (this.all)
            return true;
        return !!this.items.find(item => item.id === id);
    }
    includesAll(ids, allPlaces = false) {
        if (this.all)
            return true;
        if (allPlaces)
            return false;
        return ids.every(id => !!this.items.find(item => item.id === id));
    }
    static All() {
        return new AccessTo([], true);
    }
    static None() {
        return new AccessTo();
    }
}
exports.AccessTo = AccessTo;
exports.default = AccessTo;
